export function roundDecimalPoints(value: number) {
    return Math.round(value * 100) / 100;
}

/**
 * clamps the value within min and max
 * @param value input value
 * @param min minimum value
 * @param max max value
 */
export const clamp =
    (value: number, min: number, max: number) =>
        Math.max(min, Math.min(value, max));
